import { doorClient, resolve } from './index';

export interface GetEasyRefundBuyerListParams {
  buyerNick: string;
  pageNo: number;
  pageSize: number;
}
export type EasyRefundBuyerListResult = {
  regularRefundList: {
    id: number;
    buyerNick: string;
    operatorId: number;
    operatorName: string;
    createTime: number;
  }[];
  pageSize: number;
  pageNo: number;
  total: number;
};
export const getEasyRefundBuyerList = async (params: GetEasyRefundBuyerListParams) => {
  return resolve<EasyRefundBuyerListResult>(
    doorClient.get('/buyer-tag/v1/regular-refund/list', { params }),
  );
};

export const saveEasyRefundBuyer = async (data: { buyerNick: string[] }) => {
  return doorClient.post('/buyer-tag/v1/regular-refund', data);
};

export const deleteEasyRefundBuyer = async (id: number) => {
  return doorClient.delete('/buyer-tag/v1/regular-refund', { data: { id } });
};
